(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('RequiredDocumentDialogController', RequiredDocumentDialogController);

    RequiredDocumentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'RequiredDocument', 'Shipment', 'Keyword'];

    function RequiredDocumentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, RequiredDocument, Shipment, Keyword) {
        var vm = this;

        vm.requiredDocument = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.shipments = Shipment.query();
        vm.types = Keyword.query({filter: 'requireddocument-is-null'});
        $q.all([vm.requiredDocument.$promise, vm.types.$promise]).then(function() {
            if (!vm.requiredDocument.type || !vm.requiredDocument.type.id) {
                return $q.reject();
            }
            return Keyword.get({id : vm.requiredDocument.type.id}).$promise;
        }).then(function(type) {
            vm.types.push(type);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.requiredDocument.id !== null) {
                RequiredDocument.update(vm.requiredDocument, onSaveSuccess, onSaveError);
            } else {
                RequiredDocument.save(vm.requiredDocument, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:requiredDocumentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;
        vm.datePickerOpenStatus.received = false;
        vm.datePickerOpenStatus.approved = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
